// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '3cbb6f8f-474f-4b38-8a71-193ec4673c35',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 332,
      y: 593,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '3df910f1-da12-4df1-9851-b6bb51b3a507',
      type: 'Text',
      name: 'goBackToMenuButton',
      className: '',
      x: 0,
      y: 477,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -1000,
        y: -2000,
        width: 2000,
        height: 4000
      },
      text: 'Tap to go back Home',
      localize: true,
      maxWidth: 608,
      maxHeight: 99,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: '3b51cb07-2aa9-4ed3-8d99-e12a55060730',
      type: 'Container',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: '817c7725-32fd-4a23-ab64-c537dd7b4fa6',
      type: 'Container',
      name: 'roadProgress',
      className: '',
      x: -212,
      y: -116,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: 'ba9afc7f-18bf-498c-b953-2ed127885f64',
      type: 'Container',
      name: 'offers',
      className: '',
      x: 52,
      y: -115,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: 'c0edf782-5782-4bd1-9ad9-9cc08d8c4e94',
      type: 'Container',
      name: 'freeOffer',
      className: '',
      x: 0,
      y: -298,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: '1e9c5ec0-2fbc-4acf-aeae-cb403f2cbd4a',
      type: 'Sprite',
      name: 'title',
      className: '',
      x: 0,
      y: -375,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Title',
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: 'afd4e945-5580-4e00-914a-94f9f7497fc6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.173759,
        y: 1.025271
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Pop_Up_Background',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '6820e6f2-7154-46d5-a576-2a293b513648',
      type: 'Sprite',
      name: '',
      className: '',
      x: -212,
      y: -152,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Nod_Extremity',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: 'e5ec78d5-179b-4b22-b4a6-c3c7d7b85bd0',
      type: 'Sprite',
      name: '',
      className: '',
      x: -174,
      y: 325,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Nod_Extremity',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '0793008b-925d-4bf8-941a-9f8513c2b5a8',
      type: 'Sprite',
      name: '',
      className: '',
      x: -212,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Nod_Middle',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: 'c25c5a5e-5ccf-41a6-a2d1-a24eae85af53',
      type: 'Sprite',
      name: '',
      className: '',
      x: -212,
      y: 153,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Nod_Middle',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '38e260d4-f9ca-4ded-aa40-6de28625c6cf',
      type: 'Sprite',
      name: '',
      className: '',
      x: -212,
      y: -81,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Nod_LIne_Between',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '4f6c8658-a517-45e9-a422-c009b654b9f2',
      type: 'Sprite',
      name: '',
      className: '',
      x: -212,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Nod_LIne_Between',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '24754a09-ec19-4ee2-a958-b1a433838da3',
      type: 'Sprite',
      name: '',
      className: '',
      x: -212,
      y: 185,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Nod_LIne_Between',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '8a269ec6-69d9-4546-9436-258189f49e38',
      type: 'Sprite',
      name: '',
      className: '',
      x: 50,
      y: -116,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Background',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: 'a13bee36-b3f2-4ae7-8686-f1c92613f884',
      type: 'Sprite',
      name: '',
      className: '',
      x: 50,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Background',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '6a4f880f-3810-4d9e-89b4-8903a1851105',
      type: 'Sprite',
      name: '',
      className: '',
      x: 50,
      y: 150,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Background',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '62f81618-702f-4d77-b24a-5a080e79b4dd',
      type: 'Sprite',
      name: '',
      className: '',
      x: 50,
      y: 283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Background',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: 'add195ec-d843-4c77-925d-75c0719529f7',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -393,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Pop_Up_Blue_Top',
      parent: '3b51cb07-2aa9-4ed3-8d99-e12a55060730'
    },
    {
      id: '448233aa-cc54-42db-84e2-a5cc5b4ac05c',
      type: 'Sprite',
      name: '',
      className: 'roadLink',
      x: 0,
      y: 23,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Green_Link',
      parent: '817c7725-32fd-4a23-ab64-c537dd7b4fa6'
    },
    {
      id: 'e1fc1064-4dfc-4e68-a85b-9e359aa84bc7',
      type: 'Sprite',
      name: '',
      className: 'roadLink',
      x: 0,
      y: 156,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Green_Link',
      parent: '817c7725-32fd-4a23-ab64-c537dd7b4fa6'
    },
    {
      id: '8e05a1b9-405c-45af-8176-05b4b74b95d2',
      type: 'Sprite',
      name: '',
      className: 'roadLink',
      x: 0,
      y: 289,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Green_Link',
      parent: '817c7725-32fd-4a23-ab64-c537dd7b4fa6'
    },
    {
      id: 'f343298c-23e2-4c52-8575-315c3818b648',
      type: 'Sprite',
      name: '',
      className: 'roadDot',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Position_Dot',
      parent: '817c7725-32fd-4a23-ab64-c537dd7b4fa6'
    },
    {
      id: '372beebd-41f0-403d-8db2-5efb39ad10a6',
      type: 'Sprite',
      name: '',
      className: 'roadDot',
      x: 0,
      y: 133,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Position_Dot',
      parent: '817c7725-32fd-4a23-ab64-c537dd7b4fa6'
    },
    {
      id: '8c879ef5-f518-49fb-80da-f57ce6a91f1c',
      type: 'Sprite',
      name: '',
      className: 'roadDot',
      x: 0,
      y: 266,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Position_Dot',
      parent: '817c7725-32fd-4a23-ab64-c537dd7b4fa6'
    },
    {
      id: 'd48875e7-04e3-489f-ac57-874ae33ed330',
      type: 'Sprite',
      name: '',
      className: 'roadDot',
      x: 0,
      y: 399,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Position_Dot',
      parent: '817c7725-32fd-4a23-ab64-c537dd7b4fa6'
    },
    {
      id: 'c0494354-8339-4939-b8e3-59592a455f5b',
      type: 'Container',
      name: 'offer1Container',
      className: 'adOfferContainer',
      x: -100,
      y: -9,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ba9afc7f-18bf-498c-b953-2ed127885f64'
    },
    {
      id: '31ae59cf-b8c5-407e-ad1a-cef829f21a0e',
      type: 'Container',
      name: 'offer2Container',
      className: 'adOfferContainer',
      x: -100,
      y: 124,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ba9afc7f-18bf-498c-b953-2ed127885f64'
    },
    {
      id: '2cc701e0-4b94-49e3-8cf5-d586bef2df63',
      type: 'Container',
      name: 'offer3Container',
      className: 'adOfferContainer',
      x: -100,
      y: 257,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ba9afc7f-18bf-498c-b953-2ed127885f64'
    },
    {
      id: '038dd3ec-fa4b-4089-8714-a812e68280b3',
      type: 'Container',
      name: 'offer4Container',
      className: 'adOfferContainer',
      x: -100,
      y: 390,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ba9afc7f-18bf-498c-b953-2ed127885f64'
    },
    {
      id: '50622577-7c1c-4611-80b8-21f0aa082e62',
      type: 'Sprite',
      name: '',
      className: '',
      x: -141,
      y: 27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.617188,
        y: 0.214844
      },
      angle: 0,
      alpha: 0.9,
      visible: true,
      tint: 7320297,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_256',
      parent: 'c0edf782-5782-4bd1-9ad9-9cc08d8c4e94'
    },
    {
      id: '539b9908-99ff-469f-bdb2-81d1b4a1e36a',
      type: 'Sprite',
      name: '',
      className: '',
      x: -139,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.35,
        y: 0.25
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: 'c0edf782-5782-4bd1-9ad9-9cc08d8c4e94'
    },
    {
      id: 'ada5c26d-a918-4abf-83ab-cc6ed50a61e0',
      type: 'Sprite',
      name: '',
      className: '',
      x: -135,
      y: 48,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.4,
        y: 1.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_1',
      parent: 'c0edf782-5782-4bd1-9ad9-9cc08d8c4e94'
    },
    {
      id: 'fd92ec7b-92b3-4f11-90f8-5ecf76660b1a',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -119,
      y: 6,
      scale: {
        x: 0.38,
        y: 0.38
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 239,
      height: 128,
      leftWidth: 60,
      topHeight: 0,
      rightWidth: 60,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 29673,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pill_192x128',
      parent: 'c0edf782-5782-4bd1-9ad9-9cc08d8c4e94'
    },
    {
      id: '05fd14ba-c9e1-48f4-9f95-f7d7cc52aead',
      type: 'Text',
      name: '',
      className: 'freeOfferAmount',
      x: -73,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x5',
      localize: false,
      maxWidth: 76,
      maxHeight: 50,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 41,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c0edf782-5782-4bd1-9ad9-9cc08d8c4e94'
    },
    {
      id: 'dbde69cf-776b-44bc-8c12-cbf2400058b3',
      type: 'Container',
      name: 'freeOfferButtonSlot',
      className: '',
      x: 114,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c0edf782-5782-4bd1-9ad9-9cc08d8c4e94'
    },
    {
      id: '0179c0f6-bdab-4700-850e-5b1d622763b9',
      type: 'Container',
      name: 'freeButton',
      className: '',
      x: 106,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'c0edf782-5782-4bd1-9ad9-9cc08d8c4e94',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'ae503d98-bd28-4fd5-b278-79e8fe20f3d2',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 25,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.523438,
        y: 0.15625
      },
      angle: 0,
      alpha: 0.9,
      visible: true,
      tint: 15892035,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_256',
      parent: 'c0494354-8339-4939-b8e3-59592a455f5b'
    },
    {
      id: '0e3b3942-c63d-4111-a860-9ccad7b7c5f5',
      type: 'Sprite',
      name: '',
      className: 'adOfferIcon',
      x: 2,
      y: 32,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: 'c0494354-8339-4939-b8e3-59592a455f5b'
    },
    {
      id: '099b1538-9d62-4b3d-8c96-62245bc51225',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -40,
      y: 26,
      scale: {
        x: 0.23,
        y: 0.23
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 349,
      height: 128,
      leftWidth: 60,
      topHeight: 0,
      rightWidth: 60,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 12989184,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pill_192x128',
      parent: 'c0494354-8339-4939-b8e3-59592a455f5b'
    },
    {
      id: '94f5e58a-2587-488a-a058-63fdba71defb',
      type: 'Text',
      name: '',
      className: 'adOfferAmount',
      x: 0,
      y: 41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x15',
      localize: false,
      maxWidth: 76,
      maxHeight: 50,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c0494354-8339-4939-b8e3-59592a455f5b'
    },
    {
      id: '8bff8612-0913-4c9c-8af2-18d5890c8984',
      type: 'Container',
      name: '',
      className: 'adOfferButtonSlot',
      x: 179,
      y: 11,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c0494354-8339-4939-b8e3-59592a455f5b'
    },
    {
      id: '5f901734-2e4a-4800-a279-a34d10454bca',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 25,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.523438,
        y: 0.15625
      },
      angle: 0,
      alpha: 0.9,
      visible: true,
      tint: 15892035,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_256',
      parent: '31ae59cf-b8c5-407e-ad1a-cef829f21a0e'
    },
    {
      id: '89cb73d2-b431-4828-879f-e87179556f1b',
      type: 'Sprite',
      name: '',
      className: 'adOfferIcon',
      x: 2,
      y: 32,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.92,
        y: 0.92
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_4',
      parent: '31ae59cf-b8c5-407e-ad1a-cef829f21a0e'
    },
    {
      id: '62055011-9e4b-4e18-9a83-09627b9caab7',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -40,
      y: 26,
      scale: {
        x: 0.23,
        y: 0.23
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 349,
      height: 128,
      leftWidth: 60,
      topHeight: 0,
      rightWidth: 60,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 12989184,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pill_192x128',
      parent: '31ae59cf-b8c5-407e-ad1a-cef829f21a0e'
    },
    {
      id: '6a58c131-3931-4b7a-8cc1-36118a1bfef3',
      type: 'Text',
      name: '',
      className: 'adOfferAmount',
      x: 0,
      y: 41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x25',
      localize: false,
      maxWidth: 76,
      maxHeight: 50,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '31ae59cf-b8c5-407e-ad1a-cef829f21a0e'
    },
    {
      id: '114acbd4-c3b3-4ef3-a800-fe23a052fc27',
      type: 'Container',
      name: '',
      className: 'adOfferButtonSlot',
      x: 179,
      y: 11,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '31ae59cf-b8c5-407e-ad1a-cef829f21a0e'
    },
    {
      id: '2a6fcefc-5d76-4dc0-a2f3-aaf1d57541b7',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 25,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.316406,
        y: 0.09375
      },
      angle: 0,
      alpha: 0.9,
      visible: true,
      tint: 15892035,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_256',
      parent: '2cc701e0-4b94-49e3-8cf5-d586bef2df63'
    },
    {
      id: '51881054-4c59-41f3-8475-d7d21b89b9ea',
      type: 'Sprite',
      name: '',
      className: 'adOfferIcon',
      x: 2,
      y: 32,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Reward_Infinite_Lives',
      parent: '2cc701e0-4b94-49e3-8cf5-d586bef2df63'
    },
    {
      id: '379ca7bf-4979-4496-88a1-cb978ecce846',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -40,
      y: 26,
      scale: {
        x: 0.23,
        y: 0.23
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 349,
      height: 128,
      leftWidth: 60,
      topHeight: 0,
      rightWidth: 60,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 12989184,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pill_192x128',
      parent: '2cc701e0-4b94-49e3-8cf5-d586bef2df63'
    },
    {
      id: 'c317f65e-9f4e-43ae-8055-071127b0b16c',
      type: 'Text',
      name: '',
      className: 'adOfferAmount',
      x: 0,
      y: 41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '15',
      localize: false,
      maxWidth: 76,
      maxHeight: 50,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2cc701e0-4b94-49e3-8cf5-d586bef2df63'
    },
    {
      id: '28b1b052-56d1-44b9-b3c1-edeb514d7240',
      type: 'Container',
      name: '',
      className: 'adOfferButtonSlot',
      x: 179,
      y: 11,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2cc701e0-4b94-49e3-8cf5-d586bef2df63'
    },
    {
      id: 'ec4209dc-858e-4032-b801-49c863c12e2d',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 25,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.605469,
        y: 0.191406
      },
      angle: 0,
      alpha: 0.9,
      visible: true,
      tint: 15892035,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_256',
      parent: '038dd3ec-fa4b-4089-8714-a812e68280b3'
    },
    {
      id: '8366ae41-91db-4fc8-adef-eec76c678dd2',
      type: 'Sprite',
      name: '',
      className: 'adOfferIcon',
      x: 2,
      y: 32,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_6',
      parent: '038dd3ec-fa4b-4089-8714-a812e68280b3'
    },
    {
      id: '52445e06-3b2b-46ff-9d53-40860c098c0e',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -40,
      y: 26,
      scale: {
        x: 0.23,
        y: 0.23
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 349,
      height: 128,
      leftWidth: 60,
      topHeight: 0,
      rightWidth: 60,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 12989184,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pill_192x128',
      parent: '038dd3ec-fa4b-4089-8714-a812e68280b3'
    },
    {
      id: '35c14a4f-20d7-4ff6-a86e-7bde82a881d1',
      type: 'Text',
      name: '',
      className: 'adOfferAmount',
      x: 0,
      y: 41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x35',
      localize: false,
      maxWidth: 76,
      maxHeight: 50,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '038dd3ec-fa4b-4089-8714-a812e68280b3'
    },
    {
      id: '3494afe4-976d-4317-a0a7-aed2915a547a',
      type: 'Container',
      name: '',
      className: 'adOfferButtonSlot',
      x: 179,
      y: 11,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '038dd3ec-fa4b-4089-8714-a812e68280b3'
    },
    {
      id: '6e6f3073-fe8b-4882-ac96-2518d168384e',
      type: 'Layout',
      name: 'buttonCollect',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 0.75,
        y: 0.75
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '0179c0f6-bdab-4700-850e-5b1d622763b9',
      data: {
        color: 'green'
      }
    },
    {
      id: '936a09a7-28e6-41ee-aa3b-b93e05813d90',
      type: 'Layout',
      name: 'buttonCollectDisabled',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 0.75,
        y: 0.75
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '0179c0f6-bdab-4700-850e-5b1d622763b9',
      data: {
        color: 'grey'
      }
    },
    {
      id: '859291af-27cb-4f7a-8fdb-796a49eac13b',
      type: 'Text',
      name: '',
      className: 'upperCase_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect',
      localize: true,
      maxWidth: 230,
      maxHeight: 76,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#006f0d',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0179c0f6-bdab-4700-850e-5b1d622763b9',
      stateByName: {
        noFreeReward: {
          style: {
            stroke: '#484848'
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 1171,
  version: '1.0.0',
  stateNames: [
    'noFreeReward'
  ],
  animations: [
    {
      id: 'e53f4974-e52d-4451-b6bd-3c177b319bb3',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 1400,
      blocks: [
        {
          id: '6d2bdc45-cd76-480d-8165-b770fd673619',
          type: 'Setter',
          name: '',
          track: 0,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'popup'
        },
        {
          id: 'b07b8d40-38d6-4828-833e-862bc1cdd0e0',
          type: 'Setter',
          name: '',
          track: 1,
          target: {
            scale: {
              y: 0,
              x: 0
            }
          },
          startAt: 0,
          sourceName: 'title'
        },
        {
          id: 'd4b58e80-ca85-4bb3-868f-7d1424eaf2f2',
          type: 'Setter',
          name: '',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'offer1Container'
        },
        {
          id: '1804c535-5289-4177-a127-7fa2728d613d',
          type: 'Setter',
          name: '',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'offer2Container'
        },
        {
          id: '2a0c6c3e-e1db-4c03-8d66-93f9a2c399fb',
          type: 'Setter',
          name: '',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'offer3Container'
        },
        {
          id: 'f96aaaa2-3897-4cbb-82a9-3da8645b5e77',
          type: 'Setter',
          name: '',
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'offer4Container'
        },
        {
          id: '42909e34-5d3a-4d27-be13-2698d69f038f',
          type: 'Setter',
          name: '',
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'goBackToMenuButton',
          disabled: false
        },
        {
          id: '1fa44c2f-e829-4168-87d8-2e78faba50f0',
          type: 'Tween',
          name: '',
          duration: 1000,
          track: 0,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1,
          sourceName: 'popup',
          easing: 'ElasticOut'
        },
        {
          id: 'fe381640-98ec-4df3-82dc-08a84afef37e',
          type: 'Tween',
          name: '',
          duration: 300,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 200,
          sourceName: 'offer1Container',
          easing: 'SinusoidalIn'
        },
        {
          id: '09b23a52-6a1a-4dde-b9ff-751264f06b63',
          type: 'Tween',
          name: '',
          duration: 300,
          track: 3,
          target: {
            alpha: 1
          },
          startAt: 250,
          sourceName: 'offer2Container',
          easing: 'SinusoidalIn'
        },
        {
          id: '3bb6b7fd-ca68-41d6-8d3a-dac6dde46956',
          type: 'Tween',
          name: '',
          duration: 300,
          track: 4,
          target: {
            alpha: 1
          },
          startAt: 300,
          sourceName: 'offer3Container',
          easing: 'SinusoidalIn'
        },
        {
          id: '2f108699-de3e-4f83-89ab-f29df62dd6f4',
          type: 'Tween',
          name: '',
          duration: 300,
          track: 5,
          target: {
            alpha: 1
          },
          startAt: 350,
          sourceName: 'offer4Container',
          easing: 'SinusoidalIn'
        },
        {
          id: '096ba1b8-3239-448b-a03e-6e912872b568',
          type: 'Tween',
          name: '',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 422,
          sourceName: 'title',
          easing: 'ExponentialOut'
        },
        {
          id: 'f804b2ab-1c59-429a-9a96-e9d03a0e11d3',
          type: 'Tween',
          name: '',
          duration: 400,
          track: 0,
          target: {
            alpha: 1
          },
          startAt: 1000,
          sourceName: 'goBackToMenuButton',
          easing: 'SinusoidalOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class DailyRewardPopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container;
  goBackToMenuButton!: Text;
  background!: Container;
  roadProgress!: Container;
  offers!: Container;
  freeOffer!: Container;
  title!: Sprite;
  offer1Container!: Container;
  offer2Container!: Container;
  offer3Container!: Container;
  offer4Container!: Container;
  freeOfferButtonSlot!: Container;
  freeButton!: Container & { data: typeof raw['list'][38]['data'] };
  buttonCollect!: ButtonLargeLayout & { data: typeof raw['list'][59]['data'] };
  buttonCollectDisabled!: ButtonLargeLayout & { data: typeof raw['list'][60]['data'] };
  roadLink!: (Sprite)[];
  roadDot!: (Sprite)[];
  adOfferContainer!: (Container)[];
  freeOfferAmount!: (Text)[];
  adOfferIcon!: (Sprite)[];
  adOfferAmount!: (Text)[];
  adOfferButtonSlot!: (Container)[];
  upperCase_SPL!: (Text)[];
  StateName!: 'noFreeReward';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    popup: object;
    title: object;
    offer1Container: object;
    offer2Container: object;
    offer3Container: object;
    offer4Container: object;
    goBackToMenuButton: object;
  };

  BlockTypeByName: {};

  flowData = raw.animations[0];
}
